<template>
  <div v-if="props.image && props.url && props.name && props.price" class="border-t border-border">
    <NuxtLink :to="props.url" class="text-center text-lg">
      <p class="flex py-1 text-subheading">{{ t['w.product.replacement-product.more']() }}</p>
      <div class="flex font-medium">
        <OnImg :src="props.image" class="aspect-[4/3] h-auto rounded-2xl" width="180" :alt="props.name" :title="props.name" loading="lazy" decoding="async" />
        <div class="flex h-fit flex-col self-center bg-white p-2">
          {{ props.name }}
          <div class="flex items-baseline justify-center">
            <Price class="font-semibold" :amount="props.price" exact />
          </div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import Price from '~/components/price/Price.vue'
import * as t from '~/messages'

const props = withDefaults(
  defineProps<{
    name?: string | null
    url?: string | null
    image?: string | null
    price?: number | null
  }>(),
  {
    name: null,
    url: null,
    image: null,
    price: null,
  }
)
</script>
